module.exports = __webpack_public_path__ + "static/kf-center-image-3fcfd0920e7b9bd5ab0676970c581bd7.png";